<template>
  <v-layout justify-center>

    <v-dialog v-model="dialog_status"
      scrollable max-width="1000px"
      @keydown.esc="close()">

      <v-card v-if="!!Object.keys(tk_info).length">

        <div class="steppers">
          <div class="stepper" v-for="status in ticket_status"
            :key="status.id">
            <div>
              <span v-if="tk_info.status>status.id||tk_info.status==9">
                <v-icon color="primary">mdi-check-circle</v-icon>
              </span>
              <span v-else-if="tk_info.status==status.id">
                <v-icon color="primary">mdi-check-circle-outline</v-icon>
              </span>
              <span v-else>
                <v-icon>mdi-check-circle-outline</v-icon>
              </span>
            </div>
            <div>
              <span>{{ $t('issues.'+ status.name) }}</span>
            </div>
          </div>
        </div>

        <v-card-title class="card-title">
          <div class="meta">
            <v-chip small>{{ $t('issues.' + tk_status[tk_info.status]) }}</v-chip>
            <span>{{ $t('issues.' + tk_types[tk_info.type]) }}</span>
          </div>
          <div>
            <span>#{{ tk_info.tk_id }}</span>
            <span>{{ tk_info.title }}</span>
          </div>
        </v-card-title>

        <v-card-text v-if="!!Object.keys(tk_info).length">

          <!-- Description -->
          <v-card outlined>
            <v-card-title class="body-2 ticket-title">
              <strong class="ticket-name">{{ tk_info.created_by.name }}</strong>
              <span>{{ $t('issues.reported_on') }}&nbsp;</span>
              <span>{{ tk_info.created_ts.substr(0, 10) }}</span>
            </v-card-title>
            <v-card-text class="ticket-contents">
              {{ tk_info.description }}
            </v-card-text>
          </v-card>

          <!-- Comments -->
          <div class="comments"
            v-for="(comment, i) in tk_info.comments.slice().reverse()" :key="i">
            <div>
              <v-icon>mdi-subdirectory-arrow-right</v-icon>
            </div>
            <v-card outlined>
              <v-card-title class="body-2 ticket-title">
                <strong class="ticket-name">{{ comment.created_by.name }}</strong>
                <span>{{ $t('issues.commented_on') }}&nbsp;</span>
                <span>{{ comment.created_ts.substr(0, 10) }}</span>
              </v-card-title>
              <v-card-text class="ticket-contents">
                {{ comment.comment }}
              </v-card-text>
            </v-card>
          </div>

          <!-- Reply -->
          <div class="reply" 
            v-if="tk_info.status==2||tk_info.status==3">
            <div v-if="!comment_opened">
              <v-btn small outlined color="pms205"
                @click="comment_opened=true">
                {{ $t('issues.add_a_comment') }}
              </v-btn>
            </div>
            <div v-else>
              <div class="reply-title">
                {{ $t('issues.add_a_comment') }}
              </div>
              <div>
                <v-textarea outlined v-model="comment"></v-textarea>
                <div>
                  <v-btn small text
                    @click="comment_opened=false">
                    {{ $t('issues.cancel') }}
                  </v-btn>
                  <v-btn small depressed color="primary"
                    @click="saveComment()">
                    {{ $t('issues.save') }}
                  </v-btn>
                </div>
              </div>
            </div>

          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn small text color="pms205"
            @click="close_dialog=true"
            v-if="tk_info.status<3">
            {{ $t('issues.issue_close') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small depressed color="primary"
            @click="close_dialog=true"
            v-if="tk_info.status==3">
            {{ $t('issues.issue_close') }}
          </v-btn>
          <v-btn small text @click="close()">
            {{ $t('issues.close') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Close dialog -->
    <template>
      <v-dialog v-model="close_dialog"
        width="400px">
        <v-card>
          <v-card-title>{{ $t('issues.close_request') }}</v-card-title>
          <v-card-text>
            <div>
              {{ $t('issues.close_alert') }}
            </div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="closeTicket()">
              {{ $t('issues.continue') }}
            </v-btn>
            <v-btn text @click="close_dialog=false">
              {{ $t('issues.cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { ticket_status, ticket_types } from '../../custom/model'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },

    id: {
      required: true,
    },
  },

  data() {
    return {
      ticket_status: ticket_status,
      ticket_types: ticket_types,

      comment_opened: false,
      comment: "",
      close_dialog: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      tk_info: 'ticket/my_ticket_details',
    }),

    tk_status() {
      let values = {}
      for (let i=0; i<this.ticket_status.length; i++) {
        values[this.ticket_status[i].id] = this.ticket_status[i].name
      }
      return values
    },

    tk_types() {
      let values = {}
      for (let i=0; i<this.ticket_types.length; i++) {
        values[this.ticket_types[i].id] = this.ticket_types[i].name
      }
      return values
    },
  },

  watch: {
    id: {
      async handler(val) {
        if (!!val) {
          try {
            await this.$store.dispatch('ticket/getMyTicketDetails', val)
          } catch(e) {
            this.$store.commit('error/setDialog', true)
            this.$store.commit('error/setErrorCode', e.response.status)
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    close() {
      this.comment_opened = false
      this.comment = ""
      this.$router.replace({ name: 'issues' })
    },

    async saveComment() {
      if (!!this.comment) {
        try {
          await this.$store.dispatch('ticket/comment', {
            tk_id: this.tk_info.tk_id,
            comment: this.comment,
          })
        } catch(e) {
          this.$store.commit('error/setDialog', true)
          this.$store.commit('error/setErrorCode', e.response.status)
        }
      }
    },

    async closeTicket() {
      try {
        await this.$store.dispatch('ticket/changeStatus', {
          tk_id: this.tk_info.tk_id,
          status: 9,
        })
      } catch(e) {
          this.$store.commit('error/setDialog', true)
          this.$store.commit('error/setErrorCode', e.response.status)
      } finally {
        try {
          await this.$store.dispatch('ticket/getMyTicketDetails', this.id)
          await this.$store.dispatch('ticket/getMyTickets')
        } catch(e) {
          this.$store.commit('error/setDialog', true)
          this.$store.commit('error/setErrorCode', e.response.status)
        }
        this.close_dialog = false
      }
    },
  }
}
</script>

<style scoped>
  .card-title {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .meta {
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  .meta > .v-chip {
    margin-right: 5px;
  }

  .v-card {
    width: 100%;
  }

  .ticket>div {
    border: 1px solid gray;
  }

  .ticket-title {
    background-color: #F9F9F9;
    padding: 12px !important;
  }

  .ticket-name {
    padding-right: 5px;
  }

  .ticket-contents {
    padding: 12px !important;
  }

  .comments {
    display: flex;
    flex-direction: row;
    margin-top: 12px;
  }
  
  .reply {
    margin-top: 24px;
  }

  .reply-title {
    color: rgba(0, 0, 0, 0.87) !important;
    margin-bottom: 12px;
  }

  .steppers {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 100%;
  }

  .stepper {
    padding: 12px 0;
    height: 70px;
    width: calc(33% - 27px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #F9F9F9;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/RequestDetail.vue